import React, {Component} from "react";
import { 
    Modal,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
} from "react-bootstrap";
import moment from 'moment';
import CurrencyInput from "components/CurrencyInput/CurrencyInput";
import DatePicker from "react-datepicker";


class GovernmentLoanModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            governmentLoan: this.getInitialGovernmentLoan()
        }
    }

    getInitialGovernmentLoan = () => ({
        entryType: 'Single',
        _id: '',
        period: '',
        value: '',
        loanName: '',
        startPeriod: '',
        endPeriod: '',
        periodDetails: 'FirstHalf',
        provider: 'HDMF',
        deductionType: 'Equal'
    })

    componentWillReceiveProps(newProps) {
        const {governmentLoanData = {}} = newProps;

        if(newProps.showModal && newProps.modalType === 'create' && !this.props.showModal) {
            this.setState({
                governmentLoan: this.getInitialGovernmentLoan()
            });
        }

        if(newProps.showModal && newProps.modalType === 'edit' && governmentLoanData._id) {
            this.setState({
                governmentLoan: {
                    ...this.getInitialGovernmentLoan(),
                    _id: governmentLoanData._id,
                    period: governmentLoanData.period,
                    value: governmentLoanData.value,
                    loanName: governmentLoanData.loanName,
                    periodDetails: governmentLoanData.periodDetails || 'FirstHalf',
                    provider: governmentLoanData.provider || 'HDMF',
                    deductionType: governmentLoanData.deductionType || 'Equal'
                }
            });
        }
    }

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;
    
        this.setState(prevState => ({
            governmentLoan: {
                ...prevState.governmentLoan,
                [name]: value,
            }
        }))
        
      }

      handleDateChange = (name, date) => {
        this.setState(prevState => ({
            governmentLoan: {
                ...prevState.governmentLoan,
                [name]: date
            }
        }));
    }
    
    render() {

        const {
            showModal,
            closeModal,
            modalType,
            handleGovernmentLoan
        } = this.props;

        const {
            governmentLoan
        } = this.state;

        const {
            _id,
            entryType,
            value,
            period,
            loanName,
            startPeriod,
            endPeriod,
            periodDetails,
            provider,
            deductionType
        } = governmentLoan;

        return(
            <Modal 
                show={showModal} 
                onHide={closeModal} 
                className="confirm-modal"
            >
                <Modal.Header>
                <Modal.Title>{modalType === "create" ? "Add a value" : "Edit your value"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        {/* <h4 className="text-center">{modalType === "create" ? "Add a value to table" : "Edit your value"}</h4>*/}                    <div className="d-flex">
                        {!_id 
                            ?   <>
                                    <FormGroup>
                                        <ControlLabel>Type</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            name="entryType"
                                            value={entryType}
                                            onChange={this.handleFormChange}
                                        >
                                            <option value="Single">Single Entry</option>
                                            <option value="Multiple">Multiple Entries</option>
                                        </FormControl>
                                    </FormGroup> 
                                    {entryType === 'Single' ? <>
                                        <FormGroup>
                                            <ControlLabel>Period</ControlLabel>
                                            <DatePicker
                                                dateFormat="MMMM/yyyy"
                                                className="form-control"
                                                showMonthYearPicker
                                                onChange={(period) => this.handleDateChange('period', period)}
                                                dropdownMode="select"
                                                selected={Date.parse(period)}
                                                placeholderText="xx/xxxx"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>Period Details</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="periodDetails"
                                                value={periodDetails}
                                                onChange={this.handleFormChange}
                                            >
                                                <option value="FirstHalf">First Half</option>
                                                <option value="SecondHalf">Second Half</option>
                                            </FormControl>
                                        </FormGroup>
                                        </> : <>
                                        <FormGroup>
                                            <ControlLabel>Start Period</ControlLabel>
                                            <DatePicker
                                                dateFormat="MMMM/yyyy"
                                                className="form-control"
                                                showMonthYearPicker
                                                onChange={(period) => this.handleDateChange('startPeriod', period)}
                                                dropdownMode="select"
                                                selected={Date.parse(startPeriod)}
                                                placeholderText="xx/xxxx"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>End Period</ControlLabel>
                                            <DatePicker
                                                dateFormat="MMMM/yyyy"
                                                className="form-control"
                                                showMonthYearPicker
                                                onChange={(period) => this.handleDateChange('endPeriod', period)}
                                                dropdownMode="select"
                                                selected={Date.parse(endPeriod)}
                                                placeholderText="xx/xxxx"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>Deduction Type</ControlLabel>
                                            <FormControl
                                                componentClass="select"
                                                name="deductionType"
                                                value={deductionType}
                                                onChange={this.handleFormChange}
                                            >
                                                <option value="Equal">Divide Equaly</option>
                                                <option value="First">100% 1st Half</option>
                                                <option value="Second">100% 2nd half</option>
                                            </FormControl>
                                        </FormGroup>
                                    </>}
                                </>
                            :   <>
                                    <FormGroup>
                                        <ControlLabel>Period</ControlLabel>
                                        <FormControl
                                        type="text"
                                        name="period"
                                        disabled
                                        value={`${moment.utc(period).format('MMMM/yyyy')} - ${moment.utc(period).format('DD') === '16'  ? 'Second half' : 'First half'}` || "N/A"}
                                        />
                                    </FormGroup>
                                </>
                        }
                        <FormGroup>
                            <ControlLabel>Value</ControlLabel>
                            <CurrencyInput
                                name="value"
                                placeholder="PHP 0.00"
                                price={value}
                                onChange={(value) => this.handleFormChange({ target: { name: "value", value } })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Loan Name</ControlLabel>
                            <FormControl
                            type="text"
                            name="loanName"
                            onChange={this.handleFormChange}
                            value={loanName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Provider</ControlLabel>
                            <FormControl
                                componentClass="select"
                                name="provider"
                                value={provider}
                                onChange={this.handleFormChange}
                            >
                                <option value="HDMF">HDMF</option>
                                <option value="SSS">SSS</option>
                                <option value="Company">Company</option>
                            </FormControl>
                        </FormGroup>
                    </div>
                    {this.props.error &&
                        <Alert bsStyle="danger">
                            {this.props.error}
                        </Alert>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                      bsStyle="primary" 
                      pullRight 
                      fill
                      onClick={() => handleGovernmentLoan(this.state)}
                      style={{
                          textTransform: "capitalize"
                        }}
                    >
                        {modalType || "Edit"}
                    </Button>
                    <Button 
                      bsStyle="danger" 
                      pullRight 
                      fill
                      style={{
                        marginRight: "10px"
                      }}
                      onClick={() => closeModal()}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default GovernmentLoanModal
